(function () {
  function initRadianceShop() {
    var root = document.getElementById('ra-shop');
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    var isPlain = root.dataset.isPlain === 'true';
    var canDesign = root.dataset.canDesign === 'true';
    var cards = Array.from(root.querySelectorAll('.ra-product'));
    var grid = root.querySelector('#raProductGrid');
    var sort = root.querySelector('#raSort');

    var modal = document.getElementById('raModal');
    var modalClose = document.getElementById('raModalClose');
    var modalImage = document.getElementById('raModalImage');
    var modalGallery = document.getElementById('raModalGallery');
    var modalTitle = document.getElementById('raModalTitle');
    var modalPrice = document.getElementById('raModalPrice');
    var modalDescription = document.getElementById('raModalDescription');

    var quantity = document.getElementById('raQuantity');
    var qtyMinus = document.getElementById('raQtyMinus');
    var qtyPlus = document.getElementById('raQtyPlus');
    var status = document.getElementById('raStatus');

    var plainSizes = document.getElementById('raPlainSizes');
    var plainSelectedSize = document.getElementById('raPlainSelectedSize');
    var colourOptions = document.getElementById('raColourOptions');
    var selectedColourText = document.getElementById('raSelectedColour');
    var radianceSizes = document.getElementById('raRadianceSizes');
    var selectedRadianceSizeText = document.getElementById('raSelectedRadianceSize');

    var addCart = document.getElementById('raAddCart');
    var buyNow = document.getElementById('raBuyNow');
    var startDesign = document.getElementById('raStartDesign');
    var backButton = document.getElementById('raBackButton');

    var currentHandle = '';
    var currentVariantId = '';
    var currentVariants = [];
    var currentOptionNames = [];
    var currentFallbackImage = '';
    var currentImages = [];
    var selectedColour = '';

    var DESIGN_OPTION_NAMES = new Set([
      'design',
      'customisation',
      'customization',
      'print',
      'printarea',
      'printareas',
      'designarea',
      'designareas'
    ]);

    var PLAIN_DESIGN_VALUES = new Set([
      'plain',
      'none',
      'nodesign',
      'nocustomisation',
      'nocustomization',
      'blank',
      'standard'
    ]);

    if (backButton) {
      backButton.addEventListener('click', function () {
        if (window.history.length > 1) window.history.back();
        else window.location.href = getRootUrl();
      });
    }

    function getRootUrl() {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) {
        return Shopify.routes.root;
      }
      return '/';
    }

    function clearStatus() {
      if (!status) return;
      status.textContent = '';
      status.classList.remove('show', 'error');
    }

    function showStatus(message, isError) {
      if (!status) return;
      status.textContent = message;
      status.classList.add('show');
      status.classList.toggle('error', !!isError);
    }

    function updateImage(url) {
      if (!url || !modalImage) return;
      modalImage.style.opacity = '.35';
      setTimeout(function () {
        modalImage.src = url;
        modalImage.onload = function () {
          modalImage.style.opacity = '1';
        };
      }, 80);
    }

    function setActiveGalleryThumb(url) {
      if (!modalGallery) return;
      modalGallery.querySelectorAll('.ra-modal-thumb').forEach(function (button) {
        button.classList.toggle('active', button.dataset.image === url);
      });
    }

    function showGalleryImage(url) {
      if (!url) return;
      updateImage(url);
      setActiveGalleryThumb(url);
    }

    function buildProductGallery(images, fallback, title) {
      if (!modalGallery) return;
      modalGallery.innerHTML = '';

      var cleanImages = [];
      (images || []).forEach(function (url) {
        if (url && cleanImages.indexOf(url) === -1) cleanImages.push(url);
      });
      if (fallback && cleanImages.indexOf(fallback) === -1) cleanImages.unshift(fallback);

      currentVariants.forEach(function (variant) {
        var url = variant && variant.image ? variant.image : '';
        if (url && cleanImages.indexOf(url) === -1) cleanImages.push(url);
      });

      currentImages = cleanImages.slice();

      currentImages.forEach(function (url, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ra-modal-thumb';
        button.dataset.image = url;
        button.setAttribute('aria-label', 'View product image ' + (index + 1));

        var image = document.createElement('img');
        image.src = url;
        image.loading = 'lazy';
        image.alt = (title || 'Product') + ' image ' + (index + 1);

        button.appendChild(image);
        button.addEventListener('click', function () {
          showGalleryImage(url);
        });
        modalGallery.appendChild(button);
      });

      if (currentImages.length) showGalleryImage(currentImages[0]);
      modalGallery.style.display = currentImages.length ? '' : 'none';
    }

    function normalizeOptionName(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '');
    }

    function normalizeDesignValue(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '');
    }

    function getDesignOptionIndex(optionNames) {
      var names = optionNames || [];
      for (var i = 0; i < names.length; i += 1) {
        if (DESIGN_OPTION_NAMES.has(normalizeOptionName(names[i]))) return i;
      }
      return -1;
    }

    function isPlainDesignValue(value) {
      return PLAIN_DESIGN_VALUES.has(normalizeDesignValue(value));
    }

    /*
      IMPORTANT:
      When the Shopify product has a Design option, this storefront page must
      only use the Plain variant. Front/Back/Sleeve final-price variants are
      reserved for custom-designer.js after the customer starts designing.
    */
    function getSelectableVariants(variants, optionNames) {
      var list = Array.isArray(variants) ? variants : [];
      var designIndex = getDesignOptionIndex(optionNames || []);

      if (designIndex < 0) return list.slice();

      return list.filter(function (variant) {
        var value = variant && variant.options ? variant.options[designIndex] : '';
        return isPlainDesignValue(value);
      });
    }

    function getOptionIndexes(optionNames) {
      var names = optionNames || currentOptionNames || [];
      var designIndex = getDesignOptionIndex(names);
      var colourIndex = -1;
      var sizeIndex = -1;
      var nonDesignIndexes = [];

      names.forEach(function (name, index) {
        var clean = String(name || '').trim().toLowerCase();
        if (index !== designIndex) nonDesignIndexes.push(index);
        if (clean === 'colour' || clean === 'color') colourIndex = index;
        if (clean === 'size') sizeIndex = index;
      });

      if (colourIndex < 0 && !isPlain && nonDesignIndexes.length >= 2) {
        colourIndex = nonDesignIndexes[0];
      }

      if (sizeIndex < 0) {
        if (isPlain) {
          sizeIndex = nonDesignIndexes.length ? nonDesignIndexes[nonDesignIndexes.length - 1] : -1;
        } else if (nonDesignIndexes.length >= 2) {
          sizeIndex = nonDesignIndexes[1];
        } else if (nonDesignIndexes.length === 1) {
          sizeIndex = nonDesignIndexes[0];
        }
      }

      return {
        colour: colourIndex,
        size: sizeIndex,
        design: designIndex
      };
    }

    function updateDesignUrl() {
      if (!startDesign) return;

      if (!currentHandle || !currentVariantId) {
        startDesign.href = '#';
        startDesign.setAttribute('aria-disabled', 'true');
        return;
      }

      var selectedVariant = currentVariants.find(function (variant) {
        return String(variant.id) === String(currentVariantId);
      });
      var selectable = getSelectableVariants(currentVariants, currentOptionNames);
      var isSelectable = selectable.some(function (variant) {
        return String(variant.id) === String(currentVariantId);
      });

      if (!selectedVariant || !isSelectable) {
        startDesign.href = '#';
        startDesign.setAttribute('aria-disabled', 'true');
        return;
      }

      startDesign.removeAttribute('aria-disabled');
      var selectedQty = Math.max(1, parseInt(quantity.value, 10) || 1);
      startDesign.href =
        '/pages/design-studio?product=' + encodeURIComponent(currentHandle) +
        '&variant=' + encodeURIComponent(currentVariantId) +
        '&quantity=' + encodeURIComponent(selectedQty);
    }

    function findVariantById(variants, id) {
      return (variants || []).find(function (variant) {
        return String(variant.id) === String(id);
      }) || null;
    }

    function dedupeVariantsByOption(variants, optionIndex) {
      var result = [];
      var seen = {};

      (variants || []).forEach(function (variant) {
        var value = optionIndex >= 0 && variant.options && variant.options[optionIndex]
          ? String(variant.options[optionIndex])
          : 'One size';
        var key = value.trim().toLowerCase();

        if (!seen[key]) {
          seen[key] = variant;
          result.push(variant);
          return;
        }

        if (!seen[key].available && variant.available) {
          var old = seen[key];
          seen[key] = variant;
          var oldIndex = result.indexOf(old);
          if (oldIndex >= 0) result[oldIndex] = variant;
        }
      });

      return result;
    }

    function showPlainVariantMissingMessage() {
      currentVariantId = '';
      updateDesignUrl();
      showStatus('Shopify setup required: add Design = Plain for this product, then set its normal base price.', true);
      if (addCart) addCart.disabled = true;
      if (buyNow) buyNow.disabled = true;
    }

    function enablePurchaseButtons() {
      if (addCart) addCart.disabled = false;
      if (buyNow) buyNow.disabled = false;
    }

    function buildPlainSizes() {
      if (!plainSizes) return;

      plainSizes.innerHTML = '';
      var previousVariantId = currentVariantId;
      currentVariantId = '';

      var indexes = getOptionIndexes(currentOptionNames);
      var selectable = getSelectableVariants(currentVariants, currentOptionNames);

      if (indexes.design >= 0 && selectable.length === 0) {
        showPlainVariantMissingMessage();
        return;
      }

      var previousVariant = findVariantById(selectable, previousVariantId);

      if (indexes.colour >= 0) {
        if (previousVariant && previousVariant.options[indexes.colour]) {
          selectedColour = previousVariant.options[indexes.colour];
        } else {
          var firstColourVariant = selectable.find(function (variant) { return variant.available; }) || selectable[0];
          selectedColour = firstColourVariant && firstColourVariant.options
            ? (firstColourVariant.options[indexes.colour] || '')
            : '';
        }

        if (selectedColour) {
          selectable = selectable.filter(function (variant) {
            return String(variant.options[indexes.colour] || '') === String(selectedColour);
          });
        }
      }

      selectable = dedupeVariantsByOption(selectable, indexes.size);

      var firstAvailableButton = null;
      var buttonForPreviousVariant = null;

      selectable.forEach(function (variant) {
        var size = 'One size';
        if (indexes.size >= 0 && variant.options[indexes.size]) {
          size = variant.options[indexes.size];
        } else if (variant.title) {
          size = variant.title;
        }

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ra-size-btn';
        button.textContent = size;
        button.disabled = !variant.available;

        button.addEventListener('click', function () {
          if (!variant.available) return;
          clearStatus();
          enablePurchaseButtons();

          plainSizes.querySelectorAll('.ra-size-btn').forEach(function (item) {
            item.classList.remove('active');
          });
          button.classList.add('active');

          currentVariantId = variant.id;
          if (plainSelectedSize) plainSelectedSize.textContent = size;
          modalPrice.textContent = variant.price;
          updateImage(variant.image || currentFallbackImage);
          updateDesignUrl();
        });

        plainSizes.appendChild(button);

        if (variant.available && !firstAvailableButton) firstAvailableButton = button;
        if (String(variant.id) === String(previousVariantId)) buttonForPreviousVariant = button;
      });

      if (buttonForPreviousVariant && !buttonForPreviousVariant.disabled) {
        buttonForPreviousVariant.click();
      } else if (firstAvailableButton) {
        firstAvailableButton.click();
      } else {
        showStatus('This product is currently sold out.', true);
      }
    }

    function buildRadianceColours() {
      if (!colourOptions) return;

      colourOptions.innerHTML = '';
      selectedColour = '';
      currentVariantId = '';

      var indexes = getOptionIndexes(currentOptionNames);
      var selectable = getSelectableVariants(currentVariants, currentOptionNames);

      if (indexes.design >= 0 && selectable.length === 0) {
        showPlainVariantMissingMessage();
        return;
      }

      var colours = [];
      selectable.forEach(function (variant) {
        var colour = 'Default';
        if (indexes.colour >= 0 && variant.options[indexes.colour]) {
          colour = variant.options[indexes.colour];
        }
        if (colours.indexOf(colour) === -1) colours.push(colour);
      });

      colours.forEach(function (colour) {
        var available = selectable.some(function (variant) {
          var variantColour = 'Default';
          if (indexes.colour >= 0 && variant.options[indexes.colour]) {
            variantColour = variant.options[indexes.colour];
          }
          return variantColour === colour && variant.available;
        });

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ra-colour-btn';
        button.textContent = colour;
        button.disabled = !available;

        button.addEventListener('click', function () {
          if (button.disabled) return;
          clearStatus();
          enablePurchaseButtons();

          selectedColour = colour;
          colourOptions.querySelectorAll('.ra-colour-btn').forEach(function (item) {
            item.classList.remove('active');
          });
          button.classList.add('active');

          if (selectedColourText) selectedColourText.textContent = colour;
          buildRadianceSizes();
        });

        colourOptions.appendChild(button);
      });

      var firstAvailable = Array.from(colourOptions.children).find(function (button) {
        return !button.disabled;
      });

      if (firstAvailable) firstAvailable.click();
      else showStatus('This product is currently sold out.', true);
    }

    function buildRadianceSizes() {
      if (!radianceSizes) return;

      radianceSizes.innerHTML = '';
      currentVariantId = '';

      var indexes = getOptionIndexes(currentOptionNames);
      var selectable = getSelectableVariants(currentVariants, currentOptionNames);

      if (indexes.design >= 0 && selectable.length === 0) {
        showPlainVariantMissingMessage();
        return;
      }

      var matchingVariants = selectable.filter(function (variant) {
        var variantColour = 'Default';
        if (indexes.colour >= 0 && variant.options[indexes.colour]) {
          variantColour = variant.options[indexes.colour];
        }
        return variantColour === selectedColour;
      });

      matchingVariants = dedupeVariantsByOption(matchingVariants, indexes.size);

      matchingVariants.forEach(function (variant) {
        var size = 'One size';
        if (indexes.size >= 0 && variant.options[indexes.size]) {
          size = variant.options[indexes.size];
        }

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ra-radiance-size';
        button.textContent = size;
        button.disabled = !variant.available;

        button.addEventListener('click', function () {
          if (!variant.available) return;
          clearStatus();
          enablePurchaseButtons();

          radianceSizes.querySelectorAll('.ra-radiance-size').forEach(function (item) {
            item.classList.remove('active');
          });
          button.classList.add('active');

          currentVariantId = variant.id;
          if (selectedRadianceSizeText) selectedRadianceSizeText.textContent = size;
          modalPrice.textContent = variant.price;
          updateImage(variant.image || currentFallbackImage);
          updateDesignUrl();
        });

        radianceSizes.appendChild(button);
      });

      var firstAvailable = Array.from(radianceSizes.children).find(function (button) {
        return !button.disabled;
      });

      if (firstAvailable) {
        firstAvailable.click();
      } else {
        currentVariantId = '';
        updateDesignUrl();
        showStatus('This colour is currently sold out.', true);
      }
    }

    function getCardData(card) {
      var json = card.querySelector('.ra-product-json');
      if (!json) return null;
      try {
        return JSON.parse(json.textContent) || null;
      } catch (error) {
        console.error('Radiance product JSON error:', error);
        return null;
      }
    }

    function colourIndex(names) {
      var index = -1;
      var designIndex = getDesignOptionIndex(names || []);

      (names || []).forEach(function (name, i) {
        if (i === designIndex) return;
        var n = String(name || '').trim().toLowerCase();
        if (n === 'colour' || n === 'color') index = i;
      });

      return index;
    }

    function swatchBackground(name) {
      var n = String(name || '').toLowerCase().trim();
      var map = {
        'black': '#111', 'white': '#fff', 'blue': '#2563eb', 'navy': '#172554',
        'red': '#dc2626', 'green': '#16a34a', 'lime': '#84cc16', 'yellow': '#facc15',
        'orange': '#f97316', 'pink': '#ec4899', 'purple': '#7c3aed', 'violet': '#8b5cf6',
        'brown': '#7c2d12', 'maroon': '#7f1d1d', 'grey': '#9ca3af', 'gray': '#9ca3af',
        'charcoal': '#364152', 'cream': '#f5f0df', 'beige': '#e7d7bd'
      };

      if (map[n]) return map[n];
      for (var key in map) {
        if (n.indexOf(key) !== -1) return map[key];
      }
      return '#d4d4d4';
    }

    function setCardVariant(card, variant, swatch) {
      if (!variant) return;

      card.dataset.selectedVariantId = String(variant.id);
      card.dataset.price = String(variant.rawPrice || 0);
      card.dataset.priceText = variant.price || card.dataset.priceText;

      var img = card.querySelector('.ra-product-media img');
      if (img && variant.image) {
        img.src = variant.image;
        img.removeAttribute('srcset');
        img.setAttribute('data-ra-card-image', '1');
      }

      var price = card.querySelector('.ra-product-price');
      if (price && variant.price) price.textContent = variant.price;

      card.querySelectorAll('.ra-swatch').forEach(function (item) {
        item.classList.toggle('active', item === swatch);
      });
    }

    function buildCardSwatches(card, data) {
      var wrap = card.querySelector('.ra-swatches');
      if (!wrap || !data || !Array.isArray(data.variants)) return;

      wrap.innerHTML = '';

      var selectable = getSelectableVariants(data.variants, data.optionNames || []);
      var designIndex = getDesignOptionIndex(data.optionNames || []);

      if (designIndex >= 0 && selectable.length === 0) {
        card.dataset.selectedVariantId = '';
        card.dataset.plainVariantMissing = 'true';
        return;
      }

      card.removeAttribute('data-plain-variant-missing');

      var availableSelectable = selectable.filter(function (variant) {
        return variant && variant.available;
      });
      var defaultVariant = availableSelectable[0] || selectable[0];
      if (!defaultVariant) return;

      var idx = colourIndex(data.optionNames);
      if (idx < 0) {
        setCardVariant(card, defaultVariant, null);
        return;
      }

      var seen = {};
      var entries = [];

      availableSelectable.forEach(function (variant) {
        var colour = (variant.options && variant.options[idx]) || 'Default';
        var key = String(colour).trim().toLowerCase();
        if (!seen[key]) {
          seen[key] = true;
          entries.push({ colour: colour, variant: variant });
        }
      });

      if (!entries.length) {
        setCardVariant(card, defaultVariant, null);
        return;
      }

      if (entries.length >= 2) {
        entries.forEach(function (entry, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ra-swatch' + (i === 0 ? ' active' : '');
          b.dataset.colour = entry.colour;
          b.title = entry.colour;
          b.setAttribute('aria-label', 'Choose ' + entry.colour);
          b.style.background = swatchBackground(entry.colour);

          b.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            setCardVariant(card, entry.variant, b);
          });

          wrap.appendChild(b);
        });
      }

      setCardVariant(card, entries[0].variant, wrap.querySelector('.ra-swatch'));
    }

    function getSafeCardVariantId(card, data) {
      var selectable = getSelectableVariants(data.variants || [], data.optionNames || []);
      var selectedId = Number(card.dataset.selectedVariantId || 0);

      if (selectedId) {
        var validSelected = selectable.find(function (variant) {
          return Number(variant.id) === selectedId && variant.available;
        });
        if (validSelected) return selectedId;
      }

      var first = selectable.find(function (variant) { return variant.available; });
      return first ? Number(first.id) : 0;
    }

    function cardBuyNow(card, button) {
      var data = getCardData(card);
      if (!data || !Array.isArray(data.variants)) return;

      var designIndex = getDesignOptionIndex(data.optionNames || []);
      var selectable = getSelectableVariants(data.variants, data.optionNames || []);

      if (designIndex >= 0 && selectable.length === 0) {
        alert('Shopify setup required: add a Design option value named Plain for this product.');
        return;
      }

      var variantId = getSafeCardVariantId(card, data);
      if (!variantId) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.dataset.originalHtml = button.innerHTML;
      button.innerHTML = '<span style="font-size:10px">…</span>';

      fetch(getRootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (response) {
          return response.json().then(function (result) {
            if (!response.ok) {
              throw new Error(result.description || result.message || 'Unable to add this item.');
            }
            return result;
          });
        })
        .then(function () {
          window.location.href = getRootUrl() + 'checkout';
        })
        .catch(function (error) {
          console.error(error);
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.innerHTML = button.dataset.originalHtml || 'Buy';
        });
    }

    cards.forEach(function (card) {
      var data = getCardData(card);
      if (!data) return;

      /* Set every card to a safe Plain base variant immediately. */
      buildCardSwatches(card, data);

      card.addEventListener('click', function (event) {
        if (
          event.target.closest('.ra-card-buy') ||
          event.target.closest('.ra-swatch') ||
          event.target.closest('.ra-product-arrow')
        ) {
          return;
        }

        clearStatus();
        enablePurchaseButtons();

        currentHandle = card.dataset.handle;
        currentVariants = data.variants || [];
        currentOptionNames = data.optionNames || [];
        currentVariantId = card.dataset.selectedVariantId || '';
        currentImages = [];
        selectedColour = '';
        currentFallbackImage = data.fallbackImage || card.dataset.image || '';
        quantity.value = 1;

        modalTitle.textContent = card.dataset.title;
        modalPrice.textContent = card.dataset.priceText;
        modalDescription.textContent = card.dataset.description || 'Premium apparel from Radiance Apparel.';
        modalImage.alt = card.dataset.title;

        buildProductGallery(data.images || [], currentFallbackImage, card.dataset.title);

        if (isPlain) buildPlainSizes();
        else buildRadianceColours();

        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
      });

      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          card.click();
        }
      });

      var buy = card.querySelector('.ra-card-buy');
      if (buy) {
        buy.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          cardBuyNow(card, buy);
        });
      }

      var arrow = card.querySelector('.ra-product-arrow');
      if (arrow) {
        arrow.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          card.click();
        });
      }
    });

    function closeModal() {
      modal.classList.remove('open');
      document.body.style.overflow = '';
    }

    if (modalClose) modalClose.addEventListener('click', closeModal);
    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeModal();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && modal.classList.contains('open')) {
        closeModal();
      }
    });

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        var value = parseInt(quantity.value, 10) || 1;
        quantity.value = Math.max(1, value - 1);
        updateDesignUrl();
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        var value = parseInt(quantity.value, 10) || 1;
        quantity.value = value + 1;
        updateDesignUrl();
      });
    }

    if (quantity) {
      quantity.addEventListener('change', function () {
        var value = parseInt(quantity.value, 10) || 1;
        quantity.value = Math.max(1, value);
        updateDesignUrl();
      });
    }

    function validateCurrentVariantIsPlain() {
      if (!currentVariantId) {
        throw new Error('Please select an available option.');
      }

      var indexes = getOptionIndexes(currentOptionNames);
      var selectable = getSelectableVariants(currentVariants, currentOptionNames);

      if (indexes.design >= 0 && selectable.length === 0) {
        throw new Error('Shopify setup required: add Design = Plain for this product.');
      }

      var selected = selectable.find(function (variant) {
        return String(variant.id) === String(currentVariantId);
      });

      if (!selected) {
        throw new Error('Please select the Plain product variant before continuing.');
      }

      return selected;
    }

    async function addSelectedVariant() {
      clearStatus();
      var selectedVariant = validateCurrentVariantIsPlain();

      var qty = Math.max(1, parseInt(quantity.value, 10) || 1);
      quantity.value = qty;

      var sectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (component) {
        var sectionId = component.dataset.sectionId;
        if (sectionId && sectionIds.indexOf(sectionId) === -1) {
          sectionIds.push(sectionId);
        }
      });

      var payload = {
        items: [{
          id: Number(selectedVariant.id),
          quantity: qty
        }],
        sections: sectionIds,
        sections_url: window.location.pathname
      };

      var response = await fetch(getRootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      var result = {};
      try {
        result = await response.json();
      } catch (error) {
        console.error('Radiance: invalid cart response', error);
      }

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Unable to add this item.');
      }

      return result;
    }

    function refreshRadianceCartSections(sections) {
      if (!sections) return;

      Object.keys(sections).forEach(function (sectionId) {
        var html = sections[sectionId];
        if (!html) return;

        var parsed = new DOMParser().parseFromString(html, 'text/html');

        var currentDrawer = document.querySelector('cart-drawer-component');
        var newDrawer = parsed.querySelector('cart-drawer-component');
        if (currentDrawer && newDrawer) {
          currentDrawer.replaceWith(newDrawer);
          return;
        }

        var selector = 'cart-items-component[data-section-id="' + CSS.escape(sectionId) + '"]';
        var currentItems = document.querySelector(selector);
        var newItems = parsed.querySelector(selector);
        if (currentItems && newItems) {
          currentItems.replaceWith(newItems);
          return;
        }

        var currentSection = document.getElementById('shopify-section-' + sectionId);
        var newSection = parsed.getElementById('shopify-section-' + sectionId);
        if (currentSection && newSection) {
          currentSection.replaceWith(newSection);
        }
      });
    }

    async function openRadianceCartDrawer() {
      try {
        await customElements.whenDefined('cart-drawer-component');
      } catch (error) {
        console.error('Radiance: cart drawer component error', error);
      }

      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer) {
        console.error('Radiance: cart-drawer-component not found');
        return;
      }

      if (typeof drawer.open === 'function') {
        drawer.open();
        return;
      }

      var dialog = drawer.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
        dialog.showModal();
      }
    }

    if (addCart) {
      addCart.addEventListener('click', async function () {
        addCart.disabled = true;
        addCart.textContent = 'Adding...';

        try {
          var result = await addSelectedVariant();
          refreshRadianceCartSections(result.sections);
          closeModal();

          setTimeout(function () {
            openRadianceCartDrawer();
          }, 120);

          addCart.disabled = false;
          addCart.textContent = 'Add to Cart';
        } catch (error) {
          console.error('Radiance add to cart failed:', error);
          showStatus(error.message, true);
          addCart.disabled = false;
          addCart.textContent = 'Add to Cart';
        }
      });
    }

    if (buyNow) {
      buyNow.addEventListener('click', async function () {
        buyNow.disabled = true;
        buyNow.textContent = 'Preparing checkout...';

        try {
          await addSelectedVariant();
          window.location.href = getRootUrl() + 'checkout';
        } catch (error) {
          showStatus(error.message, true);
          buyNow.disabled = false;
          buyNow.textContent = 'Buy Now';
        }
      });
    }

    if (startDesign) {
      startDesign.addEventListener('click', function (event) {
        try {
          validateCurrentVariantIsPlain();
        } catch (error) {
          event.preventDefault();
          showStatus(error.message, true);
        }
      });
    }

    if (sort) {
      sort.addEventListener('change', function () {
        var value = sort.value;
        var sorted = cards.slice();

        if (value === 'az') {
          sorted.sort(function (a, b) {
            return String(a.dataset.cardTitle || '').localeCompare(String(b.dataset.cardTitle || ''));
          });
        } else if (value === 'za') {
          sorted.sort(function (a, b) {
            return String(b.dataset.cardTitle || '').localeCompare(String(a.dataset.cardTitle || ''));
          });
        } else if (value === 'low') {
          sorted.sort(function (a, b) {
            return Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
          });
        } else if (value === 'high') {
          sorted.sort(function (a, b) {
            return Number(b.dataset.price || 0) - Number(a.dataset.price || 0);
          });
        }

        sorted.forEach(function (card) {
          grid.appendChild(card);
        });
      });
    }
  }

  initRadianceShop();

  document.addEventListener('shopify:section:load', function () {
    var root = document.getElementById('ra-shop');
    if (root) root.removeAttribute('data-ready');
    initRadianceShop();
  });
})();
